import React, { useEffect, useState } from "react"; 
import { Link,useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import { API_BASE_URL } from "../config";

const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(0); // 🔥 triggers rerender when markup table changes

  useEffect(() => {
    const fetchOrders = async () => {
      let userData = localStorage.getItem("user");

      if (!userData) {
        console.error("No user data found in localStorage");
        return;
      }

      try {
        const user = JSON.parse(userData);
        const userId = user?.userId;
        const companyid = user?.companyId;

        const response = await axios.get(
          `${API_BASE_URL}/Order/GetOrderItemsDetails?userId=${userId}&companyid=${companyid}`
        );

        setOrders(response.data.data || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [forceUpdate]); // ⬅ rerender when markup table changes

  // 🔥 LIVE MARKUP FUNCTION
  const applyMarkup = (base) => {
    const view = localStorage.getItem("activeView") || "wholesale";
    if (view === "wholesale") return base;

    const storedPayload = JSON.parse(localStorage.getItem("priceTable_seller") || "{}");
    const table = Array.isArray(storedPayload.data) ? storedPayload.data : [];

    if (!table.length) return base;

    const range = table.find((r) => {
      const from = parseFloat(r.from || 0);
      const to = r.to === null ? Infinity : parseFloat(r.to);
      return base >= from && base <= to;
    });

    if (!range) return base;

    const markupPercent = parseFloat(range.markup || 0);
    return base * markupPercent;
  };

  // 🔥 LISTEN FOR LOCALSTORAGE CHANGE WITHOUT REFRESH
  useEffect(() => {
    const update = () => setForceUpdate((n) => n + 1);

    window.addEventListener("storage", update);
    window.addEventListener("activeViewChanged", update);
    window.addEventListener("markupTableChanged", update);

    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("activeViewChanged", update);
      window.removeEventListener("markupTableChanged", update);
    };
  }, []);

  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />

          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r" id="yourOrders-section">
                      <div className="tab-container">
                        <h2 className="text-center">
                          <Link
                            to="/partnerdashboard"
                            style={{ color: "black" }}
                            className="btn btn-view"
                          >
                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                          </Link>
                          {" "}
                          Omnichannel Orders
                        </h2>

                        <br />

                        <div className="products-list grid">
                          <div className="row">
  {orders.length > 0 ? (
    orders
     .filter(order => order.StockCarry !== "Stockandcarry")
      .sort((a, b) => b.OrderID - a.OrderID)
      .map((order) => (
        <div
          key={`${order.OrderID}-${order.OrderItemID}`}
          className="col-md-3"
        >
          <div
            className="customise-product"
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(`/orderdetails/${order.OrderID}/${order.OrderItemID}`)
            }
          >
            {/* PRODUCT IMAGE */}
            <img
              src={order.ProductImage}
              alt="Order"
              style={{ width: "100%", borderRadius: "10px" }}
            />

            <div className="details">
              <div>
                <strong>Order ID:</strong>{" "}
                {order.OrderID} - {order.ProductCode}
              </div>

              <div>
                <strong>Order Reference:</strong>{" "}
                {order.OrderReference}
              </div>

              <div>
                <strong>Qty:</strong> {order.Quantity}
              </div>

              <div>
                <strong>Total Amount:</strong>{" "}
                {order.Currency} {Math.round(applyMarkup(order.ProductPrice))}
              </div>

              <div>
                <strong>Status:</strong>{" "}
                <span
                  style={{
                    color:
                      order.StatusName === "Delivered" ? "green" : "#000",
                  }}
                >
                  {order.StatusName}
                </span>
              </div>

              <div>
                <strong>Order Date:</strong>{" "}
                {new Date(order.OrderDate).toLocaleDateString()}
              </div>

              <div>
                <strong>Client Delivery Date:</strong>{" "}
                {new Date(order.DeliveryDate).toLocaleDateString()}
              </div>
              <div>
                                                <strong>Last Updated on:</strong>
                                                <span style={{
                                                  backgroundColor:
                                                    order.UpdatedBy === "Admin"
                                                      ? "#FF7074"
                                                      : "white",
                                                  color:
                                                    order.UpdatedBy === "Customer"
                                                      ? "black"
                                                      : "black",
                                                }}>
                                                  {order.modifiedOn
                                                    ? new Date(order.modifiedOn).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(order.modifiedOn).toLocaleDateString("en-GB")
                                                    : "-"} ({order.UpdatedBy})
                                                </span>

                                              </div>
            </div>

          
            <button
              className="btn btn-view"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `/orderdetails/${order.OrderID}/${order.OrderItemID}`
                );
              }}
            >
              View Order
            </button>
          </div>
        </div>
      ))
  ) : (
    <p>No orders found.</p>
  )}
</div>

                          {/* <div className="row">

                            {orders.length > 0 ? (
                              orders
                                .sort((a, b) => b.OrderID - a.OrderID)
                                .map((order) => (
                                  <div key={`${order.OrderID}-${order.OrderItemID}`} className="col-md-3">
                                    <div className="customise-product">

                                      <img
                                        src={order.ProductImage}
                                        alt="Order"
                                        style={{ width: "100%", borderRadius: "10px" }}
                                      />

                                      <div className="details">
                                        <div>
                                          <strong>Order ID:</strong>{" "}
                                          <span>
                                            {order.OrderID} - {order.ProductCode}
                                          </span>
                                        </div>


                                        <div>
                                          <strong>Order Reference:</strong>{" "}
                                          <span>{order.OrderReference}</span>
                                        </div>

                                        <div>
                                          <strong>Qty:</strong>{" "}
                                          <span>{order.Quantity}</span>
                                        </div>

                                        <div>
                                          <strong>Total Amount:</strong>{" "}
                                          <span>
                                           {order.Currency} {Math.round(applyMarkup(order.ProductPrice))}
                                           
                                          </span>
                                        </div>

                                        <div>
                                          <strong>Status:</strong>{" "}
                                          <span style={{ color: order.StatusName === "Delivered" ? "green" : "#000" }}>
                                            {order.StatusName}
                                          </span>
                                        </div>

                                        <div>
                                          <strong>Order Date:</strong>{" "}
                                          <span>{new Date(order.OrderDate).toLocaleDateString()}</span>
                                        </div>

                                        <div>
                                          <strong>Client Delivery Date:</strong>{" "}
                                          <span>{new Date(order.DeliveryDate).toLocaleDateString()}</span>
                                        </div>                                        
                                        <div>
  <strong>Admin Delivery Date:</strong>{" "}
  <span
    style={{
      backgroundColor:
        order.UpdatedBy?.toLowerCase() === "admin"
          ? "#ffcccc"                      // light red
          : order.UpdatedBy?.toLowerCase() === "customer"
          ? "#fff7cc"                      // light yellow
          : "transparent",
      padding: "2px 4px",
      borderRadius: "4px"
    }}
  >
    {
      !order.ApproxDeliveryDate ||
      isNaN(new Date(order.ApproxDeliveryDate)) ||
      new Date(order.ApproxDeliveryDate).getFullYear() === 1970
        ? "-"
        : new Date(order.ApproxDeliveryDate).toLocaleDateString()
    }

    {order.UpdatedBy ? ` (${order.UpdatedBy})` : ""}
  </span>
</div>

                                      </div>

                                        <Link
  to={`/orderdetails/${order.OrderID}/${order.OrderItemID}`}
  className="btn btn-view"
>
                                        View Order
                                      </Link>

                                    </div>
                                  </div>
                                ))
                            ) : (
                              <p>No orders found.</p>
                            )}

                          </div> */}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default Orders;
